import { TSPRCompany } from 'legacy/lut/classes/models/ISPRSearch'
import { IActionTemplate } from 'legacy/lut/classes/models/onboarding/ActionTemplate'
import { IActionTransition } from 'legacy/lut/classes/models/onboarding/ActionTransition'
import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { IAction } from 'legacy/lut/classes/models/onboarding/IAction'
import { INotificationTemplate } from 'legacy/lut/classes/models/onboarding/INotificationTemplate'
import { IRequest } from 'legacy/lut/classes/models/onboarding/IRequest'
import {
  IRequestData,
  IRequestDataExt,
} from 'legacy/lut/classes/models/onboarding/IRetailRequestData'
import { IUploadHistory } from 'legacy/lut/classes/models/onboarding/IUploadHistory'
import { IRequestTemplate } from 'legacy/lut/classes/models/onboarding/RequestTemplate'
import onboardingApi from 'legacy/lut/classes/services/api/OnboardingApi'
import OnboardingApi, { EOnboardingEvent } from 'legacy/lut/classes/services/api/OnboardingApi'
import { CrudConnectorsScout } from 'legacy/lut/classes/services/CrudConnectorsScout'
import { IPFPOnboardingRequest } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/FormComponents/IPFPOnboardingRequest'
import { ICollectorData } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/ICollectorData'
import { IBPegDetails } from 'legacy/lut/components/widgets/public/registrationsData/ExpandContentUtils'
import { convertToServerPaginationIfNot } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { IForm } from 'core-components/classes/models/IForm'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'
import { ProcedureInnerStorageFetcher } from 'core/types/ProcedureInnerStorageFetcher'
import logger from 'core/utils/Logger'
import { IAmsLATAMSearchResponse } from 'onboarding/classes/models/aplAmsLatam'
import { TPartnerExclusionListItem } from 'onboarding/classes/models/partnerExclusion'
import { IRequestorLA } from 'onboarding/classes/models/requestorLA'
import { showError, success } from 'onboarding/classes/services/notification'
import { IContract } from 'onboarding/components/widgets/public/admin/contracts/types'
import { IRequestSpecialization } from 'onboarding/components/widgets/public/admin/specializations/models'
import { aplService } from 'onboarding/services/aplService'
import { exceptionService } from 'onboarding/services/exceptionService'
import { notificationTemplateService } from 'onboarding/services/notificationTemplateService'
import { partnerExclusionService } from 'onboarding/services/partnerExclusionService'
import { specializationService } from 'onboarding/services/specializationService'
import { userService } from 'onboarding/services/userService'
import { findFilterItem } from 'onboarding/utils/filter'
import settings from 'src/config/settings'

import { TAmsCompany } from '../../models/IAmsSearch'
import { IBackupUser } from '../../models/IBackupUser'
import { RequestTypes } from '../../models/onboarding/Onboarding'
import { IBPRegistration } from '../../models/partner360/IBPRegistration'
import { IRegistrationData } from '../api/RegistrationDataApi'
import OnboardingStoreService from '../OnboardingStoreService'

class InitializationServiceOnboarding {
  private async initWSClient(wsKey: string, wsUrl: string) {
    const wsClient = await onboardingApi.initWSClient(wsKey, wsUrl)

    await new Promise((resolve) => {
      wsClient.on('open', async () => {
        const tokenPair = await getTokens(appGetState().app.ownerId)
        const [token] = tokenPair
        if (token) {
          await onboardingApi.authorizeByToken(wsKey, token)
        }
        resolve(true)
      })
    })
  }

  public init = async () => {
    await this.initWSClient('onboarding', settings.onboardingService.wsServer)
    await this.subscribe()

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 97,
          code: 'Dropdown',
        }),
        hierarchyRoot: null,
        defaultPaging: {
          page: 0,
          pageSize: 3000,
        },
        defaultSort: {
          field: 'SortOrder',
          dir: 'asc',
        },
        keyField: 'value',
      }),
      CrudStoreItemOnboarding.OnboardingDropdowns
    )

    CrudStore.add(
      new Crud<IRequestTemplate, number>({
        fetcher: new CrudInnerStorageFetcher<IRequestTemplate, number>('EntryId', {
          formId: 662,
          code: 'RequestTemplates',
        }),
        defaultSort: { field: 'Name', dir: 'asc' },
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
      }),
      CrudStoreItemOnboarding.RequestTemplates
    )
    CrudStore.add(
      new Crud<IActionTemplate, number>({
        fetcher: new CrudInnerStorageFetcher<IActionTemplate, number>('EntryId', {
          formId: 667,
          code: 'ActionTemplate',
        }),
        keyField: 'UUID',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
        defaultSort: [
          { field: 'SortOrder', dir: 'asc' },
          { field: 'EntryId', dir: 'asc' },
        ],
        hierarchyField: 'ParentUUID',
      }),
      CrudStoreItemOnboarding.ActionTemplates
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Process', {
          formId: 667,
          code: 'OnboardingProcessValues',
        }),
        keyField: 'Process',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItemOnboarding.OnboardingProcessValues
    )

    CrudStore.add(
      new Crud<IActionTransition, number>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 667,
          code: 'TransitionTemplatesExt',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        defaultSort: { field: 'SortOrder', dir: 'asc' },
      }),
      CrudStoreItemOnboarding.ActionTransitionsTemplate
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'Requests',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.RequestList
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 661,
          code: 'BPAllActive',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemOnboarding.BPAllActive
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('CONTACTID', {
          formId: 661,
          code: 'BPAllContacts',
        }),
        keyField: 'CONTACTID',
      }),
      CrudStoreItemOnboarding.BPAllContacts
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 661,
          code: 'BPRegisteredActiveUsersView',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemOnboarding.BPRegisteredActiveUsersView
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 661,
          code: 'BPAllUser',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItemOnboarding.BPAllUser
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'ContractRequests',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.ContractRequestList
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'BPRegistrationRequestsList',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.BPRegistrationRequestList
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'BPRegistrationListView',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.BPRegistrationListView
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'SimplePartnerRegistrationList',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.SimplePartnerRegistrationRequests
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'BPReconfirmationRequestList',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.BPReconfirmationRequestList
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'RetailOnboardingRequestsList',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.RetailOnboardingRequestsList
    )
    CrudStore.add(
      new Crud<IRequestSpecialization, number>({
        fetcher: new CrudInnerStorageFetcher<IRequestSpecialization, number>('EntryId', {
          formId: 702,
          code: 'OnboardingSpecialization-702',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        keyField: 'SpzCode',
      }),
      CrudStoreItemOnboarding.Specializations
    )
    CrudStore.add(
      new Crud<IAction, number>({
        fetcher: new CrudInnerStorageFetcher<IAction, number>('EntryId', {
          formId: 665,
          code: 'OnboardingActions',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 300,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.Actions
    )
    CrudStore.add(
      new Crud<IAction & { Transitions: string }, number>({
        fetcher: new CrudInnerStorageFetcher<IAction & { Transitions: string }, number>('EntryId', {
          formId: 665,
          code: 'OnboardingMyActions',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.MyActionsPage
    )
    CrudStore.add(
      new Crud<IAction, number>({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter) => await OnboardingStoreService.fetchActionsForGrid(filter),
        }),
        defaultPaging: {
          page: 0,
          pageSize: 300,
        },
        keyField: 'EntryId',
        connectorFetchFn: CrudConnectorsScout.fetchActions,
      }),
      CrudStoreItemOnboarding.ActionsForGrid
    )
    CrudStore.add(
      new Crud<IContract>({
        fetcher: new CrudInnerStorageFetcher('Code', {
          formId: 699,
          code: 'OnboardingContracts',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        keyField: 'Code',
        hierarchyField: 'ParentCode',
        hierarchyRoot: null,
      }),
      CrudStoreItemOnboarding.ContractsList
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 677,
          code: 'RequestFiles',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RequestFiles
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Process', {
          formId: 667,
          code: 'RequestProcessesProgress',
        }),
        keyField: 'Process',
        defaultPaging: {
          page: 0,
          pageSize: 3000,
        },
      }),
      CrudStoreItemOnboarding.ProcessesProgress
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 676,
          code: 'ActionTransitions',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 150,
        },
        defaultSort: { field: 'SortOrder', dir: 'asc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.ActionTransitions
    )
    CrudStore.add(
      new Crud<ICollectorData>({
        fetcher: new CrudInnerStorageFetcher<ICollectorData>('EntryId', {
          formId: 677,
          code: 'CollectedDataForm',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.CollectedData
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 690,
          code: 'RequestHistory',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'Created', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.RequestHistory
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 692,
          code: 'UserMapping',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.UserMapping
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 692,
          code: 'UserMapping',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemOnboarding.UserMappingTree
    )
    CrudStore.add(
      new Crud({
        // TODO: Temporary type definition. Need to replace any with actual type.
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) =>
            (await notificationTemplateService.fetchMany(filter, paging, sort)) as any,
        }),
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        skipPagingTransform: true,
        defaultSort: { field: 'Created', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.NotificationTemplatesUniqList
    )
    CrudStore.add(
      new Crud({
        // TODO: Temporary type definition. Need to replace any with actual type.
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) =>
            (await notificationTemplateService.fetchWrappers(paging, sort)) as any,
        }),
        defaultPaging: {
          page: 0,
          pageSize: 30,
        },
        skipPagingTransform: true,
        defaultSort: { field: 'Created', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.NotificationTemplatesWrappers
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('CampaignEntryId', {
          formId: 667,
          code: 'OnboardingEmailing',
        }),
        defaultSort: { field: 'CampaignEntryId', dir: 'desc' },
        keyField: 'CampaignEntryId',
      }),
      CrudStoreItemOnboarding.RequestNotifications
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('ActFormId', {
          readFromTo: async (filter, sort, paging) =>
            await OnboardingStoreService.fetchForms(filter, paging, sort),
        }),
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'Name', dir: 'asc' },
        keyField: 'ActFormId',
      }),
      CrudStoreItemOnboarding.RequestForms
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 720,
          code: 'ContractsForm',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.ContractsFormData
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 721,
          code: 'LNDRForm',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.LNRFormData
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1118,
          code: 'form-lrchampion-1118',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.LNRChampion
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 736,
          code: 'RequestorFill',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RequestorFillData
    )
    CrudStore.add(
      new Crud<IPFPOnboardingRequest>({
        fetcher: new CrudInnerStorageFetcher<IPFPOnboardingRequest>('EntryId', {
          formId: 708,
          code: 'PFPOnboardingRequests',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.PFPOnboardingRequests
    )
    CrudStore.add(
      new Crud<IPFPOnboardingRequest>({
        fetcher: new CrudInnerStorageFetcher<IPFPOnboardingRequest>('EntryId', {
          formId: 708,
          code: 'PartnerRegistrationsExt',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.PartnerRegistrations
    )
    CrudStore.add(
      new Crud<IRequestData>({
        fetcher: new CrudInnerStorageFetcher<IRequestData>('EntryId', {
          formId: 708,
          code: 'RetailOnboardingRequests',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RetailOnboardingRequests
    )
    CrudStore.add(
      new Crud<IRequestDataExt>({
        fetcher: new CrudInnerStorageFetcher<IRequestDataExt>('EntryId', {
          formId: 708,
          code: 'RetailOnboardingExtRequests',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RetailOnboardingExtRequests
    )
    CrudStore.add(
      new Crud<IBPegDetails>({
        fetcher: new ProcedureInnerStorageFetcher('EnrollmentId', {
          // TODO: Temporary type definition. Need to replace any with actual type.
          readFromTo: (filter) => OnboardingStoreService.fetchBPRegData(filter) as any,
        }),
        keyField: 'ContactID',
      }),
      CrudStoreItemOnboarding.BPRegDetails
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EnrollmentId', {
          readFromTo: (filter) => OnboardingStoreService.fetchDetailedBPReconfirmationList(filter),
        }),
        keyField: 'ContactID',
      }),
      CrudStoreItemOnboarding.BPReconfirmationDetails
    )

    CrudStore.add(
      new Crud<IBackupUser>({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) =>
            await OnboardingStoreService.fetchBackupUsers(filter, paging, sort),
        }),
        skipPagingTransform: true,
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.BackupUsersList
    )
    CrudStore.add(
      new Crud<TSPRCompany>({
        fetcher: new ProcedureInnerStorageFetcher('PartnerID', {
          readFromTo: async (filter, sort, paging) =>
            await OnboardingStoreService.simplePartnerSearch(filter, paging, sort),
        }),
        skipPagingTransform: true,
        keyField: 'PartnerID',
      }),
      CrudStoreItemOnboarding.SPRSearch
    )
    CrudStore.add(
      new Crud<TAmsCompany>({
        fetcher: new ProcedureInnerStorageFetcher('partnerID', {
          readFromTo: async (filter, sort, paging) =>
            await OnboardingStoreService.amsSearch(filter, paging, sort),
        }),
        skipPagingTransform: true,
        keyField: 'partnerID',
      }),
      CrudStoreItemOnboarding.AMSSearch
    )
    CrudStore.add(
      new Crud<IAmsLATAMSearchResponse>({
        fetcher: new ProcedureInnerStorageFetcher('taxId', {
          readFromTo: async (filter, sort, paging) => {
            try {
              const pagination = convertToServerPaginationIfNot(paging)
              const extractFilterValueOrUndefined = (filter: IDataProviderFilter, field: string) =>
                (findFilterItem(filter, field)?.value as string) || undefined
              const companyName = extractFilterValueOrUndefined(filter, 'companyName')
              const countryISO = extractFilterValueOrUndefined(filter, 'countryISO')
              const taxId = extractFilterValueOrUndefined(filter, 'taxId')

              if (!(companyName || countryISO || taxId)) {
                return { Data: [] }
              }

              const items = await aplService.searchLA({
                companyName,
                countryISO,
                taxId,
                page: pagination.page,
                size: pagination.pageSize,
                skipTotal: true,
                sort: sort ? [sort].flat() : [],
              })

              return {
                Data: items,
              }
            } catch (e: any) {
              return { Data: [], Errors: e.message || 'System error' }
            }
          },
        }),
        skipPagingTransform: true,
        keyField: 'taxId',
        defaultPaging: {
          page: 1,
          pageSize: 5,
          startPage: 1,
        },
      }),
      CrudStoreItemOnboarding.AplAmsLatamSearch
    )
    CrudStore.add(
      new Crud<IRegistrationData>({
        fetcher: new ProcedureInnerStorageFetcher('id', {
          // TODO: Temporary type definition. Need to replace any with actual type.
          readFromTo: async (filter, sort, paging) =>
            (await OnboardingStoreService.fetchPartnersForBPRegistrationStatusCheckNew(
              filter,
              paging
            )) as any,
        }),
        keyField: 'id',
      }),
      CrudStoreItemOnboarding.BPRegistrationStatusCheckNew
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 745,
          code: 'OnboardingExceptions',
        }),
        keyField: 'Code',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'Type',
              operator: Operator.EQUAL,
              value: RequestTypes.Exception,
            },
          ],
        },
      }),
      CrudStoreItemOnboarding.ExceptionsList
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 745,
          code: 'OnboardingExceptions',
        }),
        keyField: 'Code',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'Type',
              operator: Operator.EQUAL,
              value: RequestTypes.RetailException,
            },
          ],
        },
      }),
      CrudStoreItemOnboarding.RetailExceptionsList
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 746,
          code: 'OnboardingExceptionCategories',
        }),
        keyField: 'Code',
        hierarchyField: 'ParentCode',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'Type',
              operator: Operator.EQUAL,
              value: RequestTypes.Exception,
            },
          ],
        },
        connectorFetchFn: async (items) => {
          return items.map((item: any) => {
            if (!item['ParentCode']) {
              item['ParentCode'] = null
            }
            return item
          })
        },
      }),
      CrudStoreItemOnboarding.ExceptionsReasonsList
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('id', {
          readFromTo: async () => {
            const result: { Data: { id: string }[] } = { Data: [] }
            try {
              const items = await exceptionService.listGroups()
              result.Data = items.map((i) => ({ id: i }))
            } catch (e: any) {
              logger.error(e)
            }

            return result
          },
        }),
        keyField: 'id',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemOnboarding.ExceptionGroups
    )
    CrudStore.add(
      new Crud<IRequest, number>({
        fetcher: new CrudInnerStorageFetcher<IRequest, number>('EntryId', {
          formId: 661,
          code: 'ExceptionsRequestsView',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItemOnboarding.ExceptionsRequestsList
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('programElement', {
          readFromTo: async (filter) => {
            const result: {
              Data: { programElement: string; programElementOrder: number | null }[]
            } = { Data: [] }
            try {
              result.Data = await specializationService.listProgramElements(filter)
            } catch (e: any) {
              logger.error(e)
            }

            return result
          },
        }),
        keyField: 'programElement',
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
      }),
      CrudStoreItemOnboarding.SpecializationProgramElements
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 746,
          code: 'OnboardingExceptionCategories',
        }),
        keyField: 'Code',
        hierarchyField: 'ParentCode',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'Type',
              operator: Operator.EQUAL,
              value: RequestTypes.RetailException,
            },
          ],
        },
        connectorFetchFn: async (items) => {
          return items.map((item: any) => {
            if (!item['ParentCode']) {
              item['ParentCode'] = null
            }
            return item
          })
        },
      }),
      CrudStoreItemOnboarding.RetailExceptionsReasonsList
    )
    CrudStore.add(
      new Crud<INotificationTemplate>({
        fetcher: new CrudInnerStorageFetcher<INotificationTemplate>('EntryId', {
          formId: 697,
          code: 'UniqNotificationTemplates',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.UniqNotificationTemplates
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Domain', {
          formId: 745,
          code: 'ONB_UniqueExceptionsDomainIsProduction',
        }),
        keyField: 'Domain',
      }),
      CrudStoreItemOnboarding.ExceptionsDomains
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('id', {
          readFromTo: (filter) => userService.fetchManyByCrudOptions(filter),
        }),
        hierarchyRoot: null,
        keyField: 'id',
        skipPagingTransform: true,
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItemOnboarding.OnboardingUsers
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('id', {
          readFromTo: async (filter, sort, paging) => {
            const response = await OnboardingStoreService.getUploadHistory(filter, paging, sort)

            if (response && response.status === 'success' && response.data) {
              return { Data: response.data.items }
            } else {
              showError(response?.message || 'Failed to getUploadHistory')
            }

            return { Data: [] }
          },
        }),
        hierarchyRoot: null,
        keyField: 'id',
        skipPagingTransform: true,
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItemOnboarding.UploadHistory
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) => {
            const result: { Data: TPartnerExclusionListItem[]; Errors?: string } = {
              Data: [],
              Errors: undefined,
            }

            try {
              result.Data = await partnerExclusionService.fetchList({
                filter,
                pagination: convertToServerPaginationIfNot(paging),
                sort: sort ? [sort].flat() : undefined,
                skipTotal: true,
              })
            } catch (e: any) {
              result.Errors = e.message || 'Failed to fetch list'
            }

            return result
          },
        }),
        hierarchyRoot: null,
        keyField: 'EntryId',
        skipPagingTransform: true,
        defaultPaging: {
          page: 1,
          pageSize: 10,
          startPage: 1,
        },
      }),
      CrudStoreItemOnboarding.PartnerExclusionList
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 667,
          code: 'ActionsExpirations',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItemOnboarding.ActionsExpirations
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('CountS', {
          formId: 667,
          code: 'ActionsExpirationsCount',
        }),
        keyField: 'CountS',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItemOnboarding.ActionsExpirationsCount
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 806,
          code: 'PartnerShipLA',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.PartnerShipLA
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher<IRequestorLA>('EntryId', {
          formId: 803,
          code: 'RequestorLAFillData',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RequestorLAFillData
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher<IRequestorLA>('EntryId', {
          formId: 807,
          code: 'PartnerShipNA',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.PartnerShipNA
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 812,
          code: 'RolesMapping',
        }),
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.RolesMapping
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 831,
          code: 'contract-validate-additionalinfo-831',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.ContractValidateAddition
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 895,
          code: 'onboardingsqltriggers-895',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 50,
        },
      }),
      CrudStoreItemOnboarding.OnboardingSqlTriggersDesc
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 896,
          code: 'onboardingsqltriggersfieldsdesc-896',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 200,
        },
      }),
      CrudStoreItemOnboarding.OnboardingSqlTriggersFieldsDesc
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 667,
          code: 'BPBrokenRegs',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.BPBrokenRegs
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('CountS', {
          formId: 667,
          code: 'BPBrokenRegsCount',
        }),
        keyField: 'CountS',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItemOnboarding.BPBrokenRegsCount
    )
    CrudStore.add(
      new Crud<IBPRegistration>({
        fetcher: new CrudInnerStorageFetcher<IBPRegistration>('EntryId', {
          formId: 708,
          code: 'BPReconfirmationsExt',
        }),
        keyField: 'EntryId',
        skipSubscribersCallOnFilterChange: true,
      }),
      CrudStoreItemOnboarding.BPReconfirmationDetail
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryID', {
          formId: 667,
          code: 'BPRegDashboard',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItemOnboarding.BpRegDashboard
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 996,
          code: 'BPRegFormsStepMapping',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 20,
        },
      }),
      CrudStoreItemOnboarding.RegistrFormsConfig
    )
    CrudStore.add(
      new Crud<IRequestorLA>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1155,
          code: 'simplebpregistration-1155',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.BPSimpleRegistration
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1544,
          code: 'DSBReport',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.DSBReport
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 2053,
          code: 'ActionExpirationTimer',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemOnboarding.ExpirationTimersAdmin
    )
  }

  protected async subscribe() {
    // TODO: subscribe only for roles which has access to Import History page https://hpheroes.atlassian.net/browse/Y22-5074
    await Promise.all([
      OnboardingApi.subscribeAndListen<{ data: IUploadHistory }>(
        EOnboardingEvent.importRequestStatus,
        async (payload) => {
          const { id, Status } = payload.data
          success(`MassLoad import ID = ${id}, Status = ${Status}`)
        }
      ),
      OnboardingApi.subscribeAndListen<{ data: IUploadHistory }>(
        EOnboardingEvent.importAPLStatus,
        async (payload) => {
          const { id, Status } = payload.data
          success(`APL import ID = ${id}, Status = ${Status}`)
        }
      ),
      OnboardingApi.subscribeAndListen<{ data: IUploadHistory }>(
        EOnboardingEvent.importAPLAMSStatus,
        async (payload) => {
          const { id, Status } = payload.data
          success(`APL AMS import ID = ${id}, Status = ${Status}`)
        }
      ),
    ])
  }
}

export default new InitializationServiceOnboarding()
